/**
 * Creates a guard that prevents a callback from firing more than once per macrotask.
 *
 * Useful when a DOM event bubbles (e.g. word click → segment click) and both
 * handlers would trigger the same action. Uses setTimeout (not nextTick) because
 * nextTick resolves during microtask processing between bubbled DOM events.
 */
export function createPerTickGuard<Args extends unknown[]>(callback: (...args: Args) => void): (...args: Args) => void {
  let firedThisTick = false
  return (...args: Args) => {
    if (firedThisTick) return
    firedThisTick = true
    setTimeout(() => {
      firedThisTick = false
    }, 0)
    callback(...args)
  }
}
